import PropTypes from 'prop-types';
import CardContainer from '@@viewCommonComponents/CardContainer.jsx';
import { CardRecap } from '@fasstech/middle-design-system';
import { getIsSelected } from '@@viewHelpers/getPropsGuarantees.js';
import { prop } from 'ramda';

const GuaranteesDisabilitySelfEmployedCard = ({
  getMiddleText,
  getMiddleBoolean,
  guarantees,
  disabilityGuarantees,
  invalidityGuarantees
}) => {
  const InvalidityCard = () => {
    return (
      <CardRecap
        title={prop('title', invalidityGuarantees)}
        data={prop('options', invalidityGuarantees)}
        price={prop('price', invalidityGuarantees)}
      />
    );
  };

  const DisabilityCard = () => {
    return (
      <CardRecap
        title={prop('title', disabilityGuarantees)}
        data={prop('options', disabilityGuarantees)}
        price={prop('price', disabilityGuarantees)}
      />
    );
  };

  return (
    <CardContainer
      icon="crutches"
      iconSize={24}
      title={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_INVAL_LABEL')}>
      {getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_EST_NECESSAIRE') &&
        getIsSelected('OPTION_INCAP', guarantees) && (
        <div className="flex gap-x-2 w-full">
          <DisabilityCard />
        </div>
      )}
      {getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_INVAL_EST_NECESSAIRE') &&
        getIsSelected('OPTION_INVAL', guarantees) && (
        <div className="flex gap-x-2 w-full">
          <InvalidityCard />
        </div>
      )}
    </CardContainer>
  );
};

GuaranteesDisabilitySelfEmployedCard.propTypes = {
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  guarantees: PropTypes.object,
  disabilityGuarantees: PropTypes.object,
  invalidityGuarantees: PropTypes.object
};

export default GuaranteesDisabilitySelfEmployedCard;
